import { ApiResponse, CompanyKpis } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getCompanyKpis = async () => {
  const response = await api.get<ApiResponse<CompanyKpis>>('/arrived/kpis');

  return unwrapApiResponse(response.data);
};
